import React from "react";
import { Box, Button, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import EmailModal from "../../components/EmailModal/EmailModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "connected-react-router";
import visionCallService from "../../services/visionCallService";
import { Print, Mail } from "@mui/icons-material";
import { performanceTranscript } from "../../routes/LearningCenterRoutes";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const MyAchievementsButtons = props => {
  const {
    emailModalType,
    printUrl,
    trainingObjectId,
    trainingRecordId,
    isPassed,
    emailButtonText,
    printButtonText,
    emailUrl
  } = props;
  const { t } = useTranslation();
  const [emailSuccesfullySent, setEmailSuccesfullySent] = React.useState("");
  const [emailModalOpen, setEmailModalOpen] = React.useState(false);
  const onEmail = e => {
    if (emailModalType === "report") {
      props.push(performanceTranscript);
    }
    setEmailModalOpen(!emailModalOpen);
    e.stopPropagation();
  };

  const onPrint = e => {
    if (emailModalType === "report") {
      props.push(performanceTranscript);
    }
    window.open(printUrl, "_blank");
    e.stopPropagation();
  };

  const getEmailDialog = () => {
    if (emailModalOpen) {
      return (
        <EmailModal
          trainingObjectId={trainingObjectId}
          trainingRecordId={trainingRecordId}
          defaultEmailAddress={props.userState.user.email}
          emailModalType={emailModalType}
          open={emailModalOpen}
          onSubmit={sendEmail}
          onClose={e => onCloseDialog(e)}
          onButtonClose={e => onCloseDialog(e)}
          emailSuccesfullySent={emailSuccesfullySent}
        />
      );
    }
  };

  const sendEmail = (e, email, trainingRecordId) => {
    if (email && (trainingRecordId || emailUrl)) {
      visionCallService
        .sendEmailRequest(email, trainingRecordId, emailUrl)
        .then(response => {
          if (response && Object.keys(response).length === 0) {
            setEmailSuccesfullySent("yes");
          } else {
            setEmailSuccesfullySent("no");
          }
        });
    } else {
      setEmailSuccesfullySent("no");
    }
    e.stopPropagation();
  };

  const onCloseDialog = e => {
    setEmailSuccesfullySent("");
    setEmailModalOpen(false);
    e.stopPropagation();
  };
  const disableButton = () => {
    if (emailModalType !== "certificate") {
      return false;
    } else if (
      props.isIlt &&
      (props.isActive || props.isAttended === "No" || !isPassed)
    ) {
      return true;
    } else {
      return !isPassed;
    }
  };

  return (
    <Box display="flex" alignItems="center" justifyContent="flex-end">
      {!!printButtonText ? (
        <Button
          color="primary"
          startIcon={<Print />}
          disabled={disableButton()}
          onClick={e => onPrint(e)}
        >
          {printButtonText}
        </Button>
      ) : (
        <Tooltip title={t("learningCenterPerformance.printButtonTooltip")}>
          <div>
            <IconButton
              color="primary"
              disabled={disableButton()}
              onClick={e => onPrint(e)}
              data-qa="print-button"
              size="large"
            >
              <Print />
            </IconButton>
          </div>
        </Tooltip>
      )}
      {!!emailButtonText ? (
        <Button
          color="primary"
          startIcon={<Mail />}
          onClick={e => onEmail(e)}
          disabled={disableButton()}
        >
          {emailButtonText}
        </Button>
      ) : (
        <Tooltip title={t("learningCenterPerformance.emailButtonTooltip")}>
          <div>
            <IconButton
              color="primary"
              onClick={e => onEmail(e)}
              disabled={disableButton()}
              data-qa="email-button"
              size="large"
            >
              <Mail />
            </IconButton>
          </div>
        </Tooltip>
      )}
      {getEmailDialog()}
    </Box>
  );
};

const mapStateToProps = state => {
  return {
    userState: state.userState
  };
};

const mapDisptachToProps = dispatch => {
  return {
    dispatch,
    ...bindActionCreators({ push }, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDisptachToProps
)(MyAchievementsButtons);

MyAchievementsButtons.propTypes = {
  printUrl: PropTypes.string,
  emailModalType: PropTypes.oneOf(["certificate", "report"]),
  trainingObjectId: PropTypes.any,
  trainingRecordId: PropTypes.any,
  isIlt: PropTypes.bool,
  isActive: PropTypes.bool,
  isAttended: PropTypes.bool,
  isPassed: PropTypes.bool,
  emailButtonText: PropTypes.string,
  printButtonText: PropTypes.string
};
